module.exports = __webpack_public_path__ + "static/wff-sec5-02-da80c0c36f34a7d0d0aec012099b4803.jpg";